import { useCallback, useState } from "react";
import { NavLink } from "react-router-dom";
import Social from "./Social";
import externalUrls from "./externalUrls";
import { ReactComponent as IDOIcon } from "../../assets/icons/ido.svg";
import { ReactComponent as SwapIcon } from "../../assets/icons/swapIcon.svg";
import { ReactComponent as StakeIcon } from "../../assets/icons/stake.svg";
import { ReactComponent as BondIcon } from "../../assets/icons/bond.svg";
import { ReactComponent as DashboardIcon } from "../../assets/icons/dashboard.svg";
import { ReactComponent as SCIcon } from "../../assets/icons/sc.svg";
import { ReactComponent as DaoRewardsIcon } from "../../assets/icons/dao-rewards.svg";
import { ReactComponent as ClaimProfitIcon } from "../../assets/icons/claim-profit.svg";
// import { ReactComponent as OlympusIcon } from "../../assets/icons/olympus-nav-header.svg";
import OlympusIcon from "../../assets/icons/olympus-nav-header.png";
import { ReactComponent as UnlockIcon } from "../../assets/icons/oXPH.svg";
import { ReactComponent as PoolTogetherIcon } from "../../assets/icons/33-together.svg";
import { t, Trans } from "@lingui/macro";
import { trim, shorten } from "../../helpers";
import { useAddress, useWeb3Context } from "src/hooks/web3Context";
import useBonds from "../../hooks/Bonds";
import { Paper, Link, Box, Typography, SvgIcon } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { info } from "src/slices/MessagesSlice";
import { useDispatch } from "react-redux";

import "./sidebar.scss";

function NavContent() {
  const dispatch = useDispatch();

  const [isActive] = useState();
  const address = useAddress();
  const { chainID } = useWeb3Context();
  const { bonds } = useBonds(chainID);

  const checkPage = useCallback((match, location, page) => {
    const currentPath = location.pathname.replace("/", "");
    if (currentPath.indexOf("dashboard") >= 0 && page === "dashboard") {
      return true;
    }
    if (currentPath.indexOf("stake") >= 0 && page === "stake") {
      return true;
    }
    if (currentPath.indexOf("ido") >= 0 && page === "ido") {
      return true;
    }
    if (currentPath.indexOf("swap") >= 0 && page === "swap") {
      return true;
    }
    if (currentPath.indexOf("claimprofit") >= 0 && page === "claimprofit") {
      return true;
    }
    if (currentPath.indexOf("yp") >= 0 && page === "yp") {
      return true;
    }
    if (currentPath.indexOf("daorewards") >= 0 && page === "daorewards") {
      return true;
    }
    if (currentPath.indexOf("unlock") >= 0 && page === "unlock") {
      return true;
    }
    if ((currentPath.indexOf("bonds") >= 0 || currentPath.indexOf("choose_bond") >= 0) && page === "bonds") {
      return true;
    }
    if (currentPath.indexOf("33-together") >= 0 && page === "33-together") {
      return true;
    }
    return false;
  }, []);

  return (
    <Paper className="dapp-sidebar">
      <Box className="dapp-sidebar-inner" display="flex" justifyContent="space-between" flexDirection="column">
        <div className="dapp-menu-top">
          <Box className="branding-header">
            <Link href="https://yapdao.finance" target="_blank">
              {/* <SvgIcon
                color="primary"
                component={OlympusIcon}
                viewBox="0 0 151 100"
                style={{ minWdth: "151px", minHeight: "98px", width: "151px" }}
              /> */}
              <img src={OlympusIcon} alt="YAPDAO" style={{ width: "149px" }} />
            </Link>

            {address && (
              <div className="wallet-link">
                <Link href={`https://bscscan.io/address/${address}`} target="_blank">
                  {shorten(address)}
                </Link>
              </div>
            )}
          </Box>

          <div className="dapp-menu-links">
            <div className="dapp-nav" id="navbarNav">
              <Link
                component={NavLink}
                id="dash-nav"
                to="/dashboard"
                isActive={(match, location) => {
                  return checkPage(match, location, "dashboard");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""} `}
              >
                <Typography variant="h6">
                  <SvgIcon color="primary" component={DashboardIcon} />
                  <Trans>Dashboard</Trans>
                </Typography>
              </Link>

              <Link
                component={NavLink}
                id="stake-nav"
                to="/stake"
                isActive={(match, location) => {
                  return checkPage(match, location, "stake");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <Typography variant="h6">
                  <SvgIcon color="primary" component={StakeIcon} />
                  <Trans>Stake</Trans>
                </Typography>
              </Link>

              {/* <Link
                component={NavLink}
                id="33-together-nav"
                to="/33-together"
                isActive={(match, location) => {
                  return checkPage(match, location, "33-together");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <Typography variant="h6">
                  <SvgIcon color="primary" component={PoolTogetherIcon} />
                  3,3 Together
                </Typography>
              </Link> */}

              <Link
                component={NavLink}
                id="bond-nav"
                to="/bonds"
                isActive={(match, location) => {
                  return checkPage(match, location, "bonds");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <Typography variant="h6">
                  <SvgIcon color="primary" component={BondIcon} />
                  <Trans>Bond</Trans>
                </Typography>
              </Link>

              <div className="dapp-menu-data discounts">
                <div className="bond-discounts">
                  <Typography variant="body2">
                    <Trans>Bond discounts</Trans>
                  </Typography>
                  {bonds.map((bond, i) => (
                    <Link
                      component={!bond.isAvailable[chainID] ? "a" : NavLink}
                      to={!bond.isAvailable[chainID] ? "/bonds" : `/bonds/${bond.name}`}
                      // onClick={() => dispatch(info(t`Coming soon`))}
                      key={i}
                      className={"bond"}
                    >
                      {!bond.bondDiscount ? (
                        <Skeleton variant="text" width={"150px"} />
                      ) : (
                        <Typography variant="body2">
                          {bond.displayName}

                          <span className="bond-pair-roi">
                            {!bond.isAvailable[chainID]
                              ? t`Coming soon`
                              : `${bond.bondDiscount && trim(bond.bondDiscount * 100, 2)}%`}
                            {/* {bond.bondDiscount && trim(bond.bondDiscount * 100, 2)}% */}
                          </span>
                        </Typography>
                      )}
                    </Link>
                  ))}
                </div>
              </div>

              <Link
                component={NavLink}
                id="stake-nav"
                to="/claimprofit"
                isActive={(match, location) => {
                  return checkPage(match, location, "claimprofit");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <Typography variant="h6">
                  <SvgIcon color="primary" component={ClaimProfitIcon} />
                  <Trans>Claim Profit</Trans>
                </Typography>
              </Link>

              <Link
                component={NavLink}
                id="stake-nav"
                to="/yp"
                isActive={(match, location) => {
                  return checkPage(match, location, "yp");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <Typography variant="h6">
                  <SvgIcon color="primary" component={SCIcon} />
                  <Trans>YP</Trans>
                </Typography>
              </Link>

              <Link
                component={NavLink}
                id="stake-nav"
                to="/daorewards"
                isActive={(match, location) => {
                  return checkPage(match, location, "daorewards");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <Typography variant="h6">
                  <SvgIcon color="primary" component={DaoRewardsIcon} />
                  <Trans>DAO Rewards</Trans>
                </Typography>
              </Link>
            </div>
          </div>
          <div className="dapp-menu-external-links">
            {Object.keys(externalUrls).map((link, i) => {
              return (
                <Link key={i} onClick={() => dispatch(info(t`Coming soon`))}>
                  {/* <Link key={i} href={`${externalUrls[link].url}`} target="_blank"> */}
                  <Typography variant="h6">{externalUrls[link].icon}</Typography>
                  <Typography variant="h6">{externalUrls[link].title}</Typography>
                </Link>
              );
            })}
          </div>
          <Box
            className="dapp-menu-bottom"
            display="flex"
            justifyContent="flex-start"
            // alignItems="flex-start"
            flexDirection="column"
          >
            <div className="dapp-menu-social">
              <Social />
            </div>
          </Box>
        </div>
      </Box>
    </Paper>
  );
}

export default NavContent;
